import { AuthGate } from '@/components/ProtectedApp';
import { InfoIcon } from '@/components/common/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** The 404: the same floating card the sign-in states use. */
export const NotFound: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthGate
      title={t('notFound.title')}
      message={t('notFound.message')}
      icon={<InfoIcon size={16} />}
      actionLabel={t('notFound.action')}
      onAction={() => navigate('/')}
    />
  );
};
